import { AxiosError } from 'axios';
import { ErrorCode } from 'data/terra/api/terra/base/ErrorCode';
import { ErrorResponse } from 'data/terra/api/terra/base/ErrorResponse';
import {
  CannotFindCreatedTrackingApp,
  IamClientIdNotFoundError,
  LoyaltyClientIdNotFoundError,
  LoyaltyIamAudienceNotFoundError,
  LoyaltyInvalidClientIdError,
  LoyaltyMissingLoginConfigError,
  LoyaltyPermissionDenied,
  NotificationAppIdNotFound,
  PaymentMerchantCodeNotFoundError,
  PaymentTerminalCodeNotFoundError,
  ProjectNotFoundError,
  TrackingAppIdNotFoundError,
  TrackingAppIsPending,
  TrackingMismatchPlatform,
  TrackingPermissionDenied,
} from 'errors/TerraError';
import { BaseResult, Result } from './result';

export async function apiResult<T>(
  block: () => Promise<T>
): Promise<Result<T>> {
  try {
    const res = await block();
    return new BaseResult(res, null);
  } catch (error) {
    return new BaseResult(null, mapError(error as Error));
  }
}

export function mapError(error: Error): Error {
  try {
    const errorCode = (error as AxiosError<ErrorResponse>).response?.data.code;

    switch (errorCode) {
      case ErrorCode.InvalidParamTrackingAppIsPending:
        return new TrackingAppIsPending();
      case ErrorCode.InvalidParamTrackingMismatchPlatform:
        return new TrackingMismatchPlatform();
      case ErrorCode.InvalidParamLoyaltyInvalidClientId:
        return new LoyaltyInvalidClientIdError();
      case ErrorCode.LoyaltyMissingLoginConfig:
        return new LoyaltyMissingLoginConfigError();
      case ErrorCode.PermissionDeniedTracking:
        return new TrackingPermissionDenied();
      case ErrorCode.PermissionDeniedLoyalty:
        return new LoyaltyPermissionDenied();
      case ErrorCode.NotFoundTrackingAppId:
        return new TrackingAppIdNotFoundError();
      case ErrorCode.NotFoundNotificationAppId:
        return new NotificationAppIdNotFound();
      case ErrorCode.NotFoundIamClientId:
        return new IamClientIdNotFoundError();
      case ErrorCode.NotFoundPaymentMerchantCode:
        return new PaymentMerchantCodeNotFoundError();
      case ErrorCode.NotFoundPaymentTerminalCode:
        return new PaymentTerminalCodeNotFoundError();
      case ErrorCode.NotFoundLoyaltyIamAudience:
        return new LoyaltyIamAudienceNotFoundError();
      case ErrorCode.NotFoundLoyaltyClient:
        return new LoyaltyClientIdNotFoundError();
      case ErrorCode.ServerErrorTrackingCannotFindCreatedApp:
        return new CannotFindCreatedTrackingApp();
      case ErrorCode.NotFoundUserInProject:
        return new ProjectNotFoundError();
      default:
        return error;
    }
  } catch (_) {
    return error;
  }
}
